module.exports = __webpack_public_path__ + "static/media/source.b708639f.gif";